<div class="mainContainer mt-5 d-flex flex-column align-items-center">
  <div class="vMax wrap">
    <div class="heroWrap">
      <h2 class="headingWL">Terms & <span> Conditions</span></h2>
    </div>

    <div class="wrapper">
      <div class="cardWrap">
        <p class="vtext1">
          These Terms & Conditions (“Terms”) of (a) use of our website
          www.virsaindia.com (“Website”), our applications (“Application”) or
          any products or services in connection with the Application/,
          Website/products (“Services”) or (b) any modes of registrations or
          usage of products, including through SD cards, tablets or other
          storage/transmitting device are between Virsa The Digital Learning
          Private Limited (“Company/We/Us/Our”) and its users (“User/You/Your”).
          These Terms constitute an electronic record in accordance with the
          provisions of the Information Technology Act, 2000 and the Information
          Technology (Intermediaries guidelines) Rules, 2011 thereunder, as
          amended from time to time. Please read the Terms and the privacy
          policy of the Company (“Privacy Policy”) with respect to registration
          with us, the use of the Application, Website, Services and products
          carefully before using the Application, Website, Services or products.
          In the event of any discrepancy between the Terms and any other
          policies with respect to the Application or Website or Services or
          products, the provisions of the Terms shall prevail. Your
          use/access/browsing of the Application or Website or the Services or
          products or registration (with or without payment/with or without
          subscription) through any means shall signify Your acceptance of the
          Terms and Your agreement to be legally bound by the same. If you do
          not agree with the Terms or the Privacy Policy, please do not use the
          Application or Website or avail the Services or products. Any access
          to our Services/Application/products through
          registrations/subscription is non transferable.
        </p>
      </div>
      <div class="cardWrap">
        <ul>
          <li *ngFor="let item of data">
            <ng-container *ngIf="isArray(item); else notNested">
              <!-- This is a nested array -->
              <ul>
                <li *ngFor="let nestedItem of item">
                  <ng-container *ngIf="isArray(nestedItem); else notNested">
                    <!-- This is a further nested array -->
                    <ul>
                      <li *ngFor="let moreNestedItem of nestedItem">
                        {{ moreNestedItem }}
                      </li>
                    </ul>
                  </ng-container>
                  <ng-template #notNested>{{ nestedItem }}</ng-template>
                </li>
              </ul>
            </ng-container>
            <ng-template #notNested>{{ item }}</ng-template>
          </li>
        </ul>
      </div>
      <div class="cardWrap" *ngFor="let meta of metadata">
        <h4 class="headingBS">
          {{ meta.name1 }}<span>{{ meta.name2 }}</span>
        </h4>
        <ul>
          <li *ngFor="let detail of meta.details">
            {{ detail }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>